import '../Body.css';
import React from "react";

function Apply(props) {

    return (
        <div className="apply">
            <p className="subPageHeader"> APPLY </p>
            <p className="subPageBodyText centeredText"> Applications for our Summer 2026 program are now closed.</p>
            <div className="subPageParagraphDivider"></div>
            <p className="subPageBodyText centeredText"> Join our email list to be notified when our Winter 2026-2027 program sign ups go live.</p>
            <form className="emailForm" action="https://getform.io/f/bnlxgzrb" method="POST">
                <input className="emailText emailInput" type="email" name="email"/>
                <button className="emailText emailSubmit" type="submit">join email list</button>
            </form>
        </div>
    )
}

export default Apply;